var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.8839C10.826 15.8839 12.5772 15.1585 13.8683 13.8674C15.1595 12.5762 15.8849 10.825 15.8849 8.99902C15.8849 7.17304 15.1595 5.42185 13.8683 4.13068C12.5772 2.83952 10.826 2.11415 9 2.11415C7.17402 2.11415 5.42282 2.83952 4.13166 4.13068C2.84049 5.42185 2.11512 7.17304 2.11512 8.99902C2.11512 10.825 2.84049 12.5762 4.13166 13.8674C5.42282 15.1585 7.17402 15.8839 9 15.8839ZM9 17.0989C13.4735 17.0989 17.0998 13.4726 17.0998 8.99902C17.0998 4.52547 13.4735 0.89917 9 0.89917C4.52645 0.89917 0.900146 4.52547 0.900146 8.99902C0.900146 13.4726 4.52645 17.0989 9 17.0989Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.323994
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00022 7.90576C9.16139 7.90576 9.31596 7.96977 9.42993 8.08369C9.5439 8.19762 9.60792 8.35213 9.60792 8.51325V12.2389C9.60792 12.4 9.5439 12.5546 9.42993 12.6685C9.31596 12.7824 9.16139 12.8464 9.00022 12.8464C8.83905 12.8464 8.68448 12.7824 8.57051 12.6685C8.45654 12.5546 8.39252 12.4 8.39252 12.2389V8.51325C8.39252 8.35213 8.45654 8.19762 8.57051 8.08369C8.68448 7.96977 8.83905 7.90576 9.00022 7.90576Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.323994
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81056 5.75896C9.81056 5.97378 9.72519 6.1798 9.57324 6.33171C9.42128 6.48361 9.21519 6.56895 9.00029 6.56895C8.78539 6.56895 8.5793 6.48361 8.42734 6.33171C8.27539 6.1798 8.19002 5.97378 8.19002 5.75896C8.19002 5.54414 8.27539 5.33812 8.42734 5.18621C8.5793 5.03431 8.78539 4.94897 9.00029 4.94897C9.21519 4.94897 9.42128 5.03431 9.57324 5.18621C9.72519 5.33812 9.81056 5.54414 9.81056 5.75896Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.323994
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIconActive);
export default __webpack_public_path__ + "static/media/request_icon_active.b323b640d1f199931ee6289576d6d289.svg";
export { ForwardRef as ReactComponent };